import { render, staticRenderFns } from "./Knobchart.vue?vue&type=template&id=1af84c3a&"
import script from "./Knobchart.vue?vue&type=script&lang=js&"
export * from "./Knobchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports